<template>
    <div>
        <form @submit.prevent class="m-form" name="claimForm">
            <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
                <div class="flex-grid__item">
                    <control for="claimantName" label="Claimant Name" v-if="showNames">
                        <input autocomplete="off" v-model="claimantName"
                               required
                               name="claimantName"
                               id="claimantName"
                               v-field-control:claimantName.required="{type:'text', rules:'name'}"
                               maxlength="100"
                               type="text">
                        <control-error :show="$error('claimantName')">
                            The claimant name is required and must be a valid name
                        </control-error>
                    </control>

                    <typeahead
                            :required=true
                            :label="'Claimant Solicitors'"
                            :error-message="'The claimant solicitor is required and must be a valid name'"
                            :value="claimantSolicitor"
                            :type="'claimant_solicitors'"
                            @update="updateClaimantSolicitors"
                    ></typeahead>

                    <control for="claimaint_reference" label="Claimant Reference">
                        <input autocomplete="off" v-model="claimantReference"
                               required
                               class="input"
                               maxlength="100"
                               v-field-control:claimantReference.required="{type:'text'}"
                               name="claimaint_reference" type="text">
                        <control-error :show="$error('claimantReference')">
                            The claimant reference is required
                        </control-error>
                    </control>

                    <typeahead
                            :required=true
                            :label="'Defendant Name'"
                            :error-message="'The defendant name is required and must be a valid name'"
                            :value="defendantName"
                            :type="'defendant'"
                            @update="updateDefendant"
                    ></typeahead>

                    <control name="disease_or_accident" label="Disease or Accident?">
                        <select name="disease_or_accident"
                                id="disease_or_accident"
                                v-field-control
                                v-model="diseaseOrAccident"
                                required>
                            <option :value="null" disabled hidden>Please select...</option>
                            <option value="disease">Disease</option>
                            <option value="accident">Accident</option>
                        </select>
                        <control-error :show="$error('disease_or_accident')">
                            The disease type is required
                        </control-error>
                    </control>

                    <div v-if="diseaseOrAccident === 'disease'">
                        <control name="disease_type" label="Disease">
                            <select name="disease_type"
                                    id="disease_type"
                                    v-field-control
                                    v-model="diseaseType"
                                    required>
                                <option :value="null" disabled hidden>Please select...</option>
                                <option value="Asbestos Related Lung Cancer">Asbestos Related Lung Cancer</option>
                                <option value="Bladder Cancer">Bladder Cancer</option>
                                <option value="Kidney Cancer">Kidney Cancer</option>
                                <option value="Laryngeal Cancer">Laryngeal Cancer</option>
                                <option value="Leukemia">Leukemia</option>
                                <option value="Liver Cancer">Liver Cancer</option>
                                <option value="Mesothelioma">Mesothelioma</option>
                                <option value="Nasal Cancer">Nasal Cancer</option>
                                <option value="Skin Cancer">Skin Cancer</option>
                                <option disabled> - - -</option>
                                <option value="Other Cancer">Other Cancer &mdash; Specify Type</option>
                                <option disabled> - - -</option>
                                <option value="Other">Other &mdash; Specify Type</option>
                            </select>
                            <control-error :show="$error('disease_type')">
                                The disease type is required
                            </control-error>
                        </control>
                        <control name="disease_type_other" label="Disease Type Other"
                                 v-if="diseaseType && diseaseType.substr(0,5)==='Other'">
                            <input autocomplete="off" type="text"
                                   name="disease_type_other"
                                   id="disease_type_other"
                                   v-field-control
                                   required
                                   v-model="otherDiseaseType">
                            <control-error :show="$error('disease_type_other') || otherDiseaseType === null">
                                The disease type is required
                            </control-error>
                        </control>
                    </div>

                    <div v-if="diseaseOrAccident === 'accident'">
                        <control name="accident_type" label="Accident">
                            <select name="accident_type"
                                    id="accident_type"
                                    v-field-control
                                    v-model="accidentType"
                                    required>
                                <option :value="null" disabled hidden>Please select...</option>
                                <option value="Accident - EL">Accident - EL</option>
                                <option value="Accident - PL">Accident - PL</option>
                                <option value="Motor">Motor</option>
                                <option value="Other">Other &mdash; Specify Type</option>
                            </select>
                            <control-error :show="$error('accident_type')">
                                The accident type is required
                            </control-error>
                        </control>
                        <control name="accident_type_other" label="Accident Type Other"
                                 v-if="accidentType && accidentType.substr(0, 5) === 'Other'">
                            <input autocomplete="off" type="text"
                                   name="accident_type_other"
                                   id="accident_type_other"
                                   v-field-control
                                   required
                                   v-model="otherAccidentType">
                            <control-error :show="$error('accident_type_other') || otherAccidentType === null">
                                The accident type is required
                            </control-error>
                        </control>
                    </div>
                </div>
                <div class="flex-grid__item flex-grid--space-left">
                    <control for="your_reference" label="Your Reference">
                        <input autocomplete="off" v-model="yourReference"
                               v-field-control
                               required
                               name="your_reference"
                               maxlength="30"
                               type="text">
                        <control-error :show="$error('your_reference')">
                            Your reference is required
                        </control-error>
                    </control>
                    <control for="pre_lit_or_lit" label="Procedural Status">
                        <select name="pre_lit_or_lit" id="pre_lit_or_lit" v-model="preLitOrLit" v-field-control
                                required>
                            <option value="pre-lit">Pre-Litigation</option>
                            <option value="litigated">Litigated</option>
                        </select>
                        <control-error :show="$error('pre_lit_or_lit')">
                            Procedural status is required
                        </control-error>
                    </control>
                    <control for="date_of_service_proceedings" label="Date of Service of Proceedings"
                             v-if="preLitOrLit == 'litigated'">
                        <date-input v-model="dateOfServiceProceedings"
                                    v-field-control:date_of_service_proceedings.required="{type:'date'}"
                        ></date-input>
                        <control-error
                                :show="$error('date_of_service_proceedings') || showServiceOfProceedingsValidationMessage_required">
                            Date of service of proceedings is required in the format DD/MM/YYYY
                        </control-error>
                        <control-error :show="showServiceOfProceedingsValidationMessage_before">
                            Date of service of proceedings must be before the date of assumed settlement
                        </control-error>
                        <control-error :show="showServiceOfProceedingsValidationMessage_9years">
                            Date of service of proceeding cannot be more than 9 years before the date of assumed
                            settlement
                        </control-error>
                    </control>
                    <control for="date_of_assumed_settlement" label="Date of Assumed Settlement">
                        <date-input v-model="dateOfAssumedSettlement"
                                    v-field-control:date_of_assumed_settlement.required="{type:'date'}"
                        ></date-input>
                        <control-error :show="$error('date_of_assumed_settlement')">
                            Date of assumed settlement is required in the format DD/MM/YYYY
                        </control-error>
                        <control-warning :show="dateOfAssumedSettlementInPast">
                            <warning-box modal-name="warning">
                                <svg slot="icon" viewBox="0 0 120 120" class="m-icon m-icon--dark m-icon--small open">
                                    <use xlink:href="#warning"></use>
                                </svg>
                                <span class="c-warning-box__orange">Date of assumed settlement is in the past</span>
                            </warning-box>
                        </control-warning>
                    </control>
                    <control for="discount_rate" label="Discount Rate">
                        <select name="discount_rate" id="discount_rate" v-model="discountRate" v-field-control
                                required>
                            <option :value="-2.0">-2.00%</option>
                            <option :value="-1.5">-1.50%</option>
                            <option :value="-1.0">-1.00%</option>
                            <option :value="-0.75">-0.75%</option>
                            <option :value="-0.5">-0.50%</option>
                            <option :value="-0.25">-0.25%</option>
                            <option :value="0.0">0.00%</option>
                            <option :value="0.5">0.50%</option>
                            <option :value="1.0">1.00%</option>
                            <option :value="1.5">1.50%</option>
                            <option :value="2.0">2.00%</option>
                            <option :value="2.5">2.50%</option>
                            <option :value="3.0">3.00%</option>
                        </select>
                        <control-error :show="$error('discount_rate')">
                            Discount rate is required
                        </control-error>
                    </control>
                </div>
            </div>
            <div class="a-form-inputs flex-grid__item--full">
                <control for="claim_narrative" label="Claim Narrative"
                         tip-text="Provide a brief background to the claim and issues in dispute. This narrative will populate your counter-schedule of loss."
                         tip-icon="info"
                         tip-side="left"
                         tip-width="250"
                         tip-name="claim_narrative"
                >
                    <textarea required
                              rows="4"
                              v-field-control:claim_narrative.required="{type:'text'}"
                              v-model="narrative"
                              name="claim_narrative"
                              class="u-full-width"></textarea>
                    <control-error :show="$error('claim_narrative')">
                        The claim narrative is required
                    </control-error>
                </control>
            </div>
        </form>
        <step-button :prev-valid="false" :next-valid="isValid"></step-button>
    </div>
</template>

<script type="text/babel">
    import {mapActions, mapGetters} from 'vuex';
    import StepButton from 'components/StepButton.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import ControlWarning from 'components/form/control/Warning.vue';
    import WarningBox from 'components/modal/WarningBox.vue';
    import FormValidator from 'components/form/validator/mixin';
    import {setStepValid} from 'services/routingMethods';
    import DateInput from 'components/form/control/DateInput.vue';
    import moment from "moment";
    import Typeahead from "components/Typeahead";

    export default {
        computed: {
            ...mapGetters('fatal/estate/claimDetails', {
                detailValue: 'value',
            }),
            ...mapGetters('fatal/estate/dependencyOnIncome', {dependencyOnIncome: 'getAll'}),
            ...mapGetters('user', ['showNames']),
            claimantName: {
                get() {
                    return this.detailValue('claimantName');
                },
                set(value) {
                    this.updateDetail({key: 'claimantName', value})
                        .then(this.updateValid.bind(this));
                }
            },
            claimantSolicitor: {
                get() {
                    return this.detailValue('claimantSolicitor');
                }
            },
            claimantReference: {
                get() {
                    return this.detailValue('claimantReference');
                },
                set(value) {
                    this.updateDetail({key: 'claimantReference', value})
                        .then(this.updateValid.bind(this));
                }
            },
            yourReference: {
                get() {
                    return this.detailValue('yourReference');
                },
                set(value) {
                    this.updateDetail({key: 'yourReference', value})
                        .then(this.updateValid.bind(this));
                }
            },
            defendantName: {
                get() {
                    return this.detailValue('defendantName');
                }
            },
            narrative: {
                get() {
                    return this.detailValue('claimNarrative');
                },
                set(value) {
                    this.updateDetail({key: 'claimNarrative', value})
                        .then(this.updateValid.bind(this));
                }
            },
            diseaseOrAccident: {
                get() {
                    return this.detailValue('diseaseOrAccident');
                },
                set(value) {
                    this.updateDetail({key: 'diseaseOrAccident', value})
                        .then(() => {
                            if (this.detailValue('diseaseOrAccident') === 'disease') {
                                this.accidentType = null;
                                this.otherAccidentType = null;
                            } else if (this.detailValue('diseaseOrAccident') === 'accident') {
                                this.diseaseType = null;
                                this.otherDiseaseType = null;

                            }
                        })
                        .then(this.updateValid.bind(this));
                }
            },
            accidentType: {
                get() {
                    return this.detailValue('accidentType');
                },
                set(value) {
                    this.updateDetail({key: 'accidentType', value})
                        .then(this.updateValid.bind(this));
                }
            },
            otherAccidentType: {
                get() {
                    return this.detailValue('otherAccidentType');
                },
                set(value) {
                    this.updateDetail({key: 'otherAccidentType', value})
                        .then(this.updateValid.bind(this));
                }
            },
            diseaseType: {
                get() {
                    return this.detailValue('diseaseType');
                },
                set(value) {
                    this.updateDetail({key: 'diseaseType', value})
                        .then(this.updateValid.bind(this));
                }
            },
            otherDiseaseType: {
                get() {
                    return this.detailValue('otherDiseaseType');
                },
                set(value) {
                    this.updateDetail({key: 'otherDiseaseType', value})
                        .then(this.updateValid.bind(this));
                }
            },
            dateOfServiceProceedings: {
                get() {
                    return this.detailValue('serviceOfProceedings');
                },
                set(value) {
                    this.updateDetail({key: 'serviceOfProceedings', value})
                        .then(this.updateValid.bind(this));
                }
            },
            dateOfAssumedSettlement: {
                get() {
                    return this.detailValue('assumedSettlement');
                },
                set(value) {
                    this.updateDetail({key: 'assumedSettlement', value})
                        .then(this.updateValid.bind(this));
                }
            },
            preLitOrLit: {
                get() {
                    return this.detailValue('proceduralStatus');
                },
                set(value) {
                    this.updateDetail({key: 'proceduralStatus', value})
                        .then(this.updateValid.bind(this));
                }
            },
            discountRate: {
                get() {
                    return this.detailValue('discountRate');
                },
                set(value) {
                    this.updateDetail({key: 'discountRate', value})
                        .then(this.updateValid.bind(this));
                }
            },
            showServiceOfProceedingsValidationMessage_required: {
                get() {
                    if (!this.dateOfServiceProceedings || !this.dateOfAssumedSettlement) {
                        return false;
                    }

                    return (
                        !moment(this.dateOfServiceProceedings, 'DD/MM/YYYY').isValid()
                        || !moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY').isValid()
                    );
                }
            },
            showServiceOfProceedingsValidationMessage_9years: {
                get() {
                    if (this.showServiceOfProceedingsValidationMessage_required) {
                        return false;
                    }

                    let mServiceOfProceedings = moment(this.dateOfServiceProceedings, 'DD/MM/YYYY');
                    let mAssumedSettlement = moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                    if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                        return false;
                    }

                    return mServiceOfProceedings.diff(mAssumedSettlement, 'years') < -9;
                }
            },
            showServiceOfProceedingsValidationMessage_before: {
                get() {
                    if (this.showServiceOfProceedingsValidationMessage_required) {
                        return false;
                    }

                    let mServiceOfProceedings = moment(this.dateOfServiceProceedings, 'DD/MM/YYYY');
                    let mAssumedSettlement = moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                    if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                        return false;
                    }

                    return !mServiceOfProceedings.isBefore(mAssumedSettlement);
                }
            },
            dateOfAssumedSettlementInPast: {
                get() {
                    return moment().diff(moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY'), 'days') > 0;
                }
            },
            isValid() {
                return (
                    this.$valid()
                    && this.validServiceOfProceedings()
                    && this.isValidAccidentOrDisease()
                    && this.isValidClaimantSolicitor()
                    && this.isValidDateOfSettlement()
                    && this.isValidDefendant()
                );
            }
        },
        mixins: [
            FormValidator
        ],
        watch: {
            isValid() {
                this.updateValid();
            }
        },
        components: {
            StepButton,
            Control,
            ControlError,
            ControlWarning,
            WarningBox,
            DateInput,
            Typeahead
        },
        methods: {
            ...mapActions('fatal/estate/claimDetails', {
                updateDetail: 'update',
            }),
            ...mapActions('fatal/estate/proceduralDates', [
                'setIssueProceedings',
                'setServiceProceedings',
                'setAssumedSettlement',
                'setPreLitOrLit'
            ]),
            updateValid() {
                return setStepValid(this.isValid);
            },
            validServiceOfProceedings() {
                let mServiceOfProceedings = moment(this.dateOfServiceProceedings, 'DD/MM/YYYY');
                let mAssumedSettlement = moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                if (this.preLitOrLit == 'pre-lit') {
                    return true;
                }

                if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                    return false;
                }

                if (!mServiceOfProceedings.isBefore(mAssumedSettlement)) {
                    return false;
                }

                return mServiceOfProceedings.diff(mAssumedSettlement, 'years') >= -9;
            },
            isValidAccidentOrDisease() {
                if (this.diseaseOrAccident === 'disease') {
                    return (
                        this.diseaseType !== null
                        && (
                            (this.diseaseType.substr(0, 5) === 'Other' && this.otherDiseaseType !== null && this.otherDiseaseType.length >= 1)
                            || this.diseaseType.substr(0, 5) !== 'Other'
                        )
                    );
                }

                if (this.diseaseOrAccident === 'accident') {
                    return (
                        this.accidentType !== null
                        && (
                            (this.accidentType.substr(0, 5) === 'Other' && this.otherAccidentType !== null && this.otherAccidentType.length >= 1)
                            || this.accidentType.substr(0, 5) !== 'Other'
                        )
                    );
                }

                return false;
            },
            isValidClaimantSolicitor() {
                return this.claimantSolicitor
                    && this.claimantSolicitor.name !== null
                    && this.claimantSolicitor.name !== '';
            },
            isValidDateOfSettlement() {
                return moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY', true);
            },
            isValidDefendant() {
                return this.defendantName
                    && this.defendantName.name !== null
                    && this.defendantName.name !== '';
            },
            updateClaimantSolicitors(value) {
                this.updateDetail({key: 'claimantSolicitor', value})
                    .then(this.updateValid.bind(this));
            },
            updateDefendant(value) {
                this.updateDetail({key: 'defendantName', value})
                    .then(this.updateValid.bind(this));
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ClaimDetails.vue?982a34bc